


const baseGeneralUrl = "General"
  const endpoints = {
   getAlarmWaysList:`${baseGeneralUrl}/GetNotificationTypes`,
   
  
  };
  
  export default endpoints;
  



